import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-step-one',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './step-one.component.html',
  styleUrl: './step-one.component.scss',
})
export class StepOneComponent {
  @Input({ required: true }) profileForm!: FormGroup;

  selectedFileName = '';
  isDragOver = false;

  get showUploadSection(): boolean {
    return !!this.profileForm.get('uploadDocument')?.value;
  }

  get showDepartmentSection(): boolean {
    return !!this.profileForm.get('departmentFocus')?.value;
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] ?? null;
    this.updateSelectedFile(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragOver = false;
    const file = event.dataTransfer?.files?.[0] ?? null;
    this.updateSelectedFile(file);
  }

  private updateSelectedFile(file: File | null): void {
    this.selectedFileName = file?.name ?? '';
  }
}
